/** @format */
import Sections from '../organisms/sections';

function Home() {
  return (
    <main style={{ position: 'relative' }}>
      <Sections />
    </main>
  );
}

export default Home;
